module.exports = __webpack_public_path__ + "img/advisory4.c41a4edd.svg";